import WeatherExample from "../../../../docs/_images/display-example.png";
import * as React from 'react';
export default {
  WeatherExample,
  React
};